import { render, staticRenderFns } from "./UnauthorizedUsers.vue?vue&type=template&id=3792b664&scoped=true"
import script from "./UnauthorizedUsers.vue?vue&type=script&lang=js"
export * from "./UnauthorizedUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3792b664",
  null
  
)

export default component.exports